import { create } from "zustand";

import { EmailTransferObjectDto } from "@/components/DetailsSection/types";

interface EmailTransferStore {
  details: EmailTransferObjectDto[] | null;
  setDetails: (details: EmailTransferObjectDto[] | null) => void;
}

export const useEmailTransferStore = create<EmailTransferStore>()((set) => ({
  details: null,
  setDetails: (details) => set({ details })
}));
